import React, { useState, useMemo } from 'react';
import { Row, Col } from 'antd';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import LazyImageLoader from './LazyImageLoader';

const AlbumImage = ({ images }) => {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <Row gutter={[16, 16]}>
        {images.map((src, i) => (
          <Col key={i} xs={24} sm={12} md={8} lg={6}>
            <div style={{ cursor: 'pointer' }} onClick={() => setIndex(i)}>
              <LazyImageLoader src={src} alt={`Gallery ${i}`} />
            </div>
          </Col>
        ))}
      </Row>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={images.map(src => ({ src }))}
        index={index}
        onIndexChange={setIndex}
      />
    </>
  );
};

export default AlbumImage;
